import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { ArrowDownRight, ArrowUpRight, Activity, Building2 } from 'lucide-preact';
import { memo } from 'preact/compat';
import { useEffect, useState } from 'preact/hooks';
import { dashboardApi } from '@/api/dashboard';
export const CompaniesEngagedStatTile = memo(({ workspaceId, range, mock = false }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (!workspaceId)
            return;
        let cancelled = false;
        const load = async () => {
            setLoading(true);
            setError(null);
            const resp = await dashboardApi.getCompaniesEngaged(workspaceId, range, mock);
            if (!cancelled) {
                if (resp.error)
                    setError(resp.error);
                else
                    setData(resp.data || null);
                setLoading(false);
            }
        };
        load();
        return () => { cancelled = true; };
    }, [workspaceId, range, mock]);
    const growthDir = (() => {
        if (!data)
            return null;
        const d = data.CurrentWindowCompanyCount - data.PreviousWindowCompanyCount;
        if (d > 0)
            return 'up';
        if (d < 0)
            return 'down';
        return 'flat';
    })();
    const delta = data ? data.CurrentWindowCompanyCount - data.PreviousWindowCompanyCount : 0;
    const growthPct = (() => {
        if (!data)
            return null;
        const prev = data.PreviousWindowCompanyCount;
        if (prev === 0)
            return null;
        return ((delta / prev) * 100).toFixed(1);
    })();
    if (loading) {
        return (_jsxs("div", { className: "tile", children: [_jsxs("div", { className: "flex items-start justify-between mb-4", children: [_jsxs("div", { className: "flex flex-col gap-1", children: [_jsx("div", { className: "h-3 w-24 rounded-md bg-shimmer-light animate-shimmer" }), _jsx("div", { className: "h-3 w-20 rounded-md bg-shimmer-light animate-shimmer" })] }), _jsx("span", { className: "w-5 h-5 rounded-md bg-shimmer-light animate-shimmer" })] }), _jsxs("div", { className: "flex items-end gap-4 mt-auto", children: [_jsxs("div", { className: "flex-1", children: [_jsx("div", { className: "h-8 w-20 mb-2 rounded-md bg-shimmer-light animate-shimmer" }), _jsx("div", { className: "h-3 w-24 rounded-md bg-shimmer-light animate-shimmer" })] }), _jsx("div", { className: "h-5 w-12 rounded-md bg-shimmer-light animate-shimmer" })] })] }));
    }
    return (_jsxs("div", { className: "tile", children: [_jsxs("div", { className: "flex items-start justify-between mb-3", children: [_jsxs("h3", { className: "text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400 leading-tight", children: [_jsx("span", { className: "block", children: "Companies" }), _jsx("span", { className: "block", children: "Engaged" })] }), _jsx(Building2, { className: "w-5 h-5 text-primary-600 dark:text-primary-400" })] }), error && _jsx("div", { className: "text-sm text-red-600 dark:text-red-400", children: error }), !error && data && (_jsxs("div", { className: "flex items-end justify-between gap-4", children: [_jsx("div", { className: "text-4xl font-bold text-green-600 dark:text-green-400 leading-none", children: data.CurrentWindowCompanyCount.toLocaleString() }), _jsx("div", { className: "flex flex-col items-end gap-1", children: _jsxs("span", { className: `pill ${growthDir === 'up' ? 'pill-up' : growthDir === 'down' ? 'pill-down' : 'pill-flat'} text-xs2`, title: "Difference vs previous window", children: [growthDir === 'up' && _jsx(ArrowUpRight, { className: "w-3.5 h-3.5" }), growthDir === 'down' && _jsx(ArrowDownRight, { className: "w-3.5 h-3.5" }), growthDir === 'flat' && _jsx(Activity, { className: "w-3.5 h-3.5" }), _jsx("span", { children: delta === 0 ? '0' : Math.abs(delta).toLocaleString() }), growthPct !== null && growthDir !== 'flat' && _jsxs("span", { className: "opacity-70", children: ["(", growthPct, "%)"] })] }) })] })), !error && !data && (_jsx("div", { className: "text-sm text-slate-500 dark:text-slate-400", children: "No data" }))] }));
});
